module.exports = __webpack_public_path__ + "media/images/pages/img_digest_facility_02-fba8a5360c48bf72b66e7f43f70e5e25.jpg";